document.addEventListener("DOMContentLoaded", () => {
  const sizeChartDrawer = document.querySelector(".size-chart--drawer");

  /* move drawer to end of body to prevent stacking context issues
    his allows drawer to sit above the header */
  const drawerRoot = document.getElementById("drawer-root");

  // desktop only
  let isDesktop = window.matchMedia("(min-width: 1000px)").matches;
  //smaller screens
  let isSmallScreen = window.matchMedia("(max-width: 999px)").matches;
  if (
    isDesktop &&
    sizeChartDrawer &&
    sizeChartDrawer.parentNode !== drawerRoot
  ) {
    drawerRoot.appendChild(sizeChartDrawer);
  }
  sizeChartDrawer?.querySelector(".drawer__content") &&
    (sizeChartDrawer.querySelector(".drawer__content").scrollTop = 0);

  // The body-attached drawer is swapped for a freshly-rendered one whenever
  // a section re-render injects a new #pdpDrawer into the DOM (e.g. swatch
  // change that triggers product:rerender with productChange: true).
  let drawer = null;
  let previouslyFocused = null;

  const adoptDrawer = (next) => {
    if (!next || next === drawer) return;
    if (drawer && drawer.parentNode) drawer.remove();
    drawer = next;
    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }
  };

  adoptDrawer(document.getElementById("pdpDrawer"));

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        const candidate =
          node.id === "pdpDrawer" ? node : node.querySelector?.("#pdpDrawer");
        if (candidate && candidate !== drawer) {
          adoptDrawer(candidate);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  const openDrawer = (contentKey) => {
    if (!drawer) return;
    previouslyFocused = document.activeElement;

    const drawerPanel = drawer.querySelector(".pdp-drawer__panel");
    const closeBtnIcon = drawer.querySelector(".pdp-drawer__close-icon");
    const contents = drawer.querySelectorAll(".drawer-content");

    if (contentKey === "feature") {
      /* conditionally adding classes to style the feature panel
            and feature close icon differently.
          */
      drawerPanel?.classList.add("feature--panel");
      closeBtnIcon?.classList.add("drawer__close-button");
    } else {
      drawerPanel?.classList.remove("feature--panel");
      closeBtnIcon?.classList.remove("drawer__close-button");
    }

    contents.forEach((content) => {
      content.classList.toggle(
        "active",
        content.dataset.content === contentKey,
      );
    });

    drawer.classList.add("active");
    // Lock body scroll only on mobile/tablet — the drawer occupies the full
    // viewport there so background scroll would feel broken. On desktop the
    // drawer is a side panel and the rest of the page should stay scrollable.
    if (window.matchMedia("(max-width: 999px)").matches) {
      document.body.classList.add("overflow-hidden");
    }

    // reset drawer scroll
    if (drawerPanel) drawerPanel.scrollTop = 0;

    //moving keyboard focus to the top-right close icon after opening the drawer, without scrolling
    closeBtnIcon?.focus({ preventScroll: true });

    // Flickity carousels inside .drawer-content are constructed while their
    // ancestor is display:none, so their internal `untilVisible` IntersectionObserver
    // never fires and Flickity never initialises. On first open, clone & re-insert
    // each <flickity-carousel> so the custom element constructor re-runs while the
    // ancestor is now display:block and untilVisible resolves.
    const activeContent = drawer.querySelector(
      `.drawer-content[data-content="${contentKey}"]`,
    );
    activeContent?.querySelectorAll("flickity-carousel").forEach((carousel) => {
      if (carousel.dataset.pdpDrawerReinit === "1") {
        carousel.flickity
          ?.then((flkty) => flkty && flkty.resize())
          .catch(() => {});
        return;
      }
      carousel.dataset.pdpDrawerReinit = "1";
      const clone = carousel.cloneNode(true);
      carousel.parentNode.replaceChild(clone, carousel);
      clone.flickity?.then((flkty) => flkty && flkty.resize()).catch(() => {});
    });
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove("active");
    document.body.classList.remove("overflow-hidden");

    if (
      previouslyFocused &&
      typeof previouslyFocused.focus === "function" &&
      document.contains(previouslyFocused)
    ) {
      previouslyFocused.focus({ preventScroll: true });
    }
    previouslyFocused = null;
  };

  // Delegated off document so all click bindings survive section re-renders
  // (e.g. when a swatch change in .block-swatch-list rerenders the product
  // info section and replaces the original .pdp-info-btn nodes — and the
  // drawer itself — with fresh markup).
  document.addEventListener("click", (event) => {
    const openBtn = event.target.closest(".pdp-info-btn");
    if (openBtn) {
      const isDesktopNow = window.matchMedia("(min-width: 1000px)").matches;
      const contentKey = openBtn.dataset.drawerContent;
      //if desktop and the button is not the feature, open the drawers
      //if not desktop, always open all drawers
      if (!isDesktopNow || contentKey !== "feature") {
        openDrawer(contentKey);
      } else {
        event.preventDefault();
        const target = document.getElementById("product-info-sliders");
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
      return;
    }

    if (!drawer || !drawer.contains(event.target)) return;

    if (event.target.closest('[class^="pdp-drawer__close"]')) {
      closeDrawer();
      return;
    }
    if (event.target.classList.contains("pdp-drawer__overlay")) {
      closeDrawer();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDrawer();
    }
  });
});
